import { render, staticRenderFns } from "./subidos.vue?vue&type=template&id=02c6a732"
import script from "./subidos.vue?vue&type=script&lang=js"
export * from "./subidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports